//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditableTaskName from './editable-task-name.vue';
import moment from 'moment';
import confirmedActionButton from './confirmed-action-button.vue';
import {
  removePlannedFor,
  bulkRescheduleAtEnd,
} from '../ordered-relation';
import {
  isoDateFormat,
  formatDayRelative,
  formatDayAbsolute,
  formatWeek,
  formatWeekSecondary,
  formatMonth,
} from '../time-utils.js';
import {
  isSubtask,
  calcVisibility,
} from '../utils.js';
import SectionHeaderMenu from './section-header-menu.vue';

export default {
  props: ['section'],
  components: {
    confirmedActionButton,
    SectionHeaderMenu,
    EditableTaskName,
  },
  computed: {
    title() {
      if (this.section.moment) {
        switch (this.section.class) {
          case 'day':
            return formatDayRelative(this.section.moment, this.$gettext);
          case 'week':
            return formatWeek(this.section.moment, this.$gettext);
          case 'month':
            return formatMonth(this.section.moment, this.$gettext);
        }
      } else if (this.section.title) {
        if (this.section.title === "Items without a list") {
          return this.$gettext("Items without a list");
        }
        return this.section.title;
      }
      return this.section.key;
    },
    subtitle() {
      if (this.section.moment) {
        switch (this.section.class) {
          case 'day':
            return formatDayAbsolute(this.section.moment);
          case 'week':
            return formatWeekSecondary(this.section.moment);
          case 'month':
            return '';
        }
      } else if (this.section.doc && this.$root.hasSharing) {
        return this.section.doc.couch.displayName
      } else if (this.section.key === "backlog" && this.$root.hasSharing) {
        return this.section.couch.displayName
      }
      return '';
    },
    itemIcon() {
      if (!this.section.doc) return 'schedule';
      if (this.section.doc.icon) return this.section.doc.icon;
      switch (this.section.doc.type) {
        case "task": return this.isDone ? 'check_box' : 'check_box_outline_blank'
        case "goal": return this.isDone ? 'flag' : 'outlined_flag'
        case "note": return 'notes'
        case "event": return 'event'
        case "period": return 'schedule'
        case "list": {
          switch (this.section.doc.relation) {
            case "plannedFor": return "schedule"
            case "subtaskOf": return "view_list"
            case "category": return "category"
            case "status": return "assistant_direction"
          }
        }
      }
    },
    incompleteTasks() {
      return this.section.tasks.filter((item) => {
        const isDoable = item.type !== "note" && item.type !== "event"
        return isDoable && !item.doneAtTimestampMs
      })
    },
    // section that is one level "bigger"
    higherLevelSectionInfo() {
      const currentWeek = {
        parentClass: 'week',
        parentKey: moment().startOf('isoWeek').format(isoDateFormat),
      }
      const currentMonth = {
        parentClass: 'month',
        parentKey: moment().startOf('month').format(isoDateFormat),
      }
      const backlog = {parentClass: 'list', parentKey: 'backlog'}

      switch (this.section.class) {
        case 'day':
          if (this.$root.activeTimeCols.includes('weeks')) {
            return currentWeek
          } else if (this.$root.activeTimeCols.includes('months')) {
            return currentMonth
          } else {
            return backlog
          }
        case 'week':
          if (this.$root.activeTimeCols.includes('months')) {
            return currentMonth
          } else {
            return backlog
          }
        case 'month':
          return backlog
      }
    },
    totalDuration() {
      const durations = this.section.tasks
        .filter((item) => !!item.dur && calcVisibility(item, this))
        .map((item) => item.dur)

      return durations.reduce((a, b) => a + b, 0)
    },
    showDuration() {
      return !!this.totalDuration || !!this.availableTime;
    },
    availableTime() {
      const id = 'sectiondata:' + this.section.class + this.section.key
      const doc = this.$reactiveCache.docs[id]
      if (doc) {
        return doc.dur;
      } else {
        return null;
      }
    },
    isShared() {
      return (this.section.doc && this.section.doc.couch !== this.$defaultDB)
        || (this.section.couch !== this.$defaultDB)
    },
  },
  methods: {
    reschedulingText(targetClass) {
      switch (targetClass) {
        case 'day':
          return this.$gettext('Move all not done tasks to today');
        case 'week':
          return this.$gettext('Move all not done tasks to current week');
        case 'month':
          return this.$gettext('Move all not done tasks to current month');
        case 'backlog':
          return this.$gettext('Move all not done tasks to unplanned');
      }
    },
    rescheduleSectionTasks(newParentInfo) {
      // If an item's parent is scheduled in the section to which the item is
      // being moved, simply remove scheduling.
      const needRescheduling = []
      const returnToParent = []

      this.incompleteTasks.forEach((item, index) => {
        if (isSubtask(item)) {
          const parent = this.$reactiveCache.docs[item.subtaskOf.parentKey]
          if (parent.plannedFor &&
              parent.plannedFor.parentKey === newParentInfo.parentKey &&
              parent.plannedFor.parentClass === newParentInfo.parentClass) {
            returnToParent.push(item);
            return;
          }
        }
        needRescheduling.push(item);
      })

      this.$reactiveCache.freezeUntil(
          bulkRescheduleAtEnd({
            reactiveCache: this.$reactiveCache,
            tasks: needRescheduling,
            newPPtr: newParentInfo,
          }));
      for (const item of returnToParent) {
        removePlannedFor(item)
      }
    },
    rescheduleToNext() {
      const timeUnit = {
        'day': 'day',
        'week': 'isoweek',
        'month': 'month',
      }[this.section.class];
      const newParentKey = moment().startOf(timeUnit).format(isoDateFormat);
      this.rescheduleSectionTasks({
        parentClass: this.section.class,
        parentKey: newParentKey,
      });
    },
  },
};
